import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "d-flex flex-row mb-3 justify-content-between align-items-center"
};
const _hoisted_2 = {
  class: "fw-extra-bold fsi-20"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "mb-4"
}, null, -1);
const _hoisted_4 = {
  class: "mb-lg-4 mb-3"
};
const _hoisted_5 = {
  class: "row"
};
const _hoisted_6 = {
  class: "col-lg-6 col-12"
};
const _hoisted_7 = {
  class: "pl-4 pr-4"
};
const _hoisted_8 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_9 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_10 = {
  class: "fw-bold fsi-24"
};
const _hoisted_11 = {
  class: "row mt-lg-4 mt-3"
};
const _hoisted_12 = {
  class: "col-lg-6 col-12"
};
const _hoisted_13 = {
  class: "pr-4"
};
const _hoisted_14 = {
  class: "pl-4 fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_15 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_16 = {
  class: "pl-4 fw-bold fsi-24"
};
const _hoisted_17 = {
  class: "col-lg-6 col-12 mt-lg-0 mt-3"
};
const _hoisted_18 = {
  class: "pl-4 pr-4"
};
const _hoisted_19 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_20 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_21 = {
  class: "fw-bold fsi-24"
};
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", {
  class: "horizontal-dividing-line mb-4 mt-4"
}, null, -1);
const _hoisted_23 = {
  class: "row mt-4"
};
const _hoisted_24 = {
  class: "col-lg-6 col-12"
};
const _hoisted_25 = {
  class: "pl-4 pr-4"
};
const _hoisted_26 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_27 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_28 = {
  class: "fw-bold fsi-24"
};
const _hoisted_29 = {
  class: "col-lg-6 col-12 mt-lg-0 mt-3"
};
const _hoisted_30 = {
  class: "pl-4 pr-4"
};
const _hoisted_31 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_32 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_33 = {
  class: "fw-bold fsi-24"
};
const _hoisted_34 = {
  class: "row mt-lg-4 mt-3"
};
const _hoisted_35 = {
  class: "col-lg-6 col-12"
};
const _hoisted_36 = {
  class: "pl-4 pr-4"
};
const _hoisted_37 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_38 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_39 = {
  class: "fw-bold fsi-24"
};
const _hoisted_40 = {
  class: "fw-medium fs-12"
};
const _hoisted_41 = {
  class: "col-lg-6 col-12 mt-lg-0 mt-3"
};
const _hoisted_42 = {
  class: "pl-4 pr-4"
};
const _hoisted_43 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_44 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_45 = {
  class: "fw-bold fsi-24"
};
const _hoisted_46 = {
  class: "d-flex flex-row mb-3 justify-content-between align-items-center"
};
const _hoisted_47 = {
  class: "fw-extra-bold fsi-20"
};
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", {
  class: "mb-4"
}, null, -1);
const _hoisted_49 = {
  class: "mb-lg-4 mb-2"
};
const _hoisted_50 = {
  class: "row"
};
const _hoisted_51 = {
  class: "col-lg-6 col-12"
};
const _hoisted_52 = {
  class: "pl-4 pr-4"
};
const _hoisted_53 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_54 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_55 = {
  class: "fw-bold fsi-24"
};
const _hoisted_56 = {
  key: 0,
  class: "fw-bold fsi-24"
};
const _hoisted_57 = {
  key: 1,
  class: "fw-bold fsi-24"
};
const _hoisted_58 = {
  class: "row mt-lg-4 mt-3"
};
const _hoisted_59 = {
  class: "col-lg-6 col-12"
};
const _hoisted_60 = {
  class: "pr-4"
};
const _hoisted_61 = {
  class: "pl-4 fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_62 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_63 = {
  class: "pl-4 fw-bold fsi-24"
};
const _hoisted_64 = {
  key: 0,
  class: "pl-4 fw-bold fsi-24"
};
const _hoisted_65 = {
  key: 1,
  class: "pl-4 fw-bold fsi-24"
};
const _hoisted_66 = {
  class: "col-lg-6 col-12 mt-lg-0 mt-3"
};
const _hoisted_67 = {
  class: "pl-4 pr-4"
};
const _hoisted_68 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_69 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_70 = {
  class: "fw-bold fsi-24"
};
const _hoisted_71 = {
  key: 0,
  class: "fw-bold fsi-24"
};
const _hoisted_72 = {
  key: 1,
  class: "fw-bold fsi-24"
};
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", {
  class: "horizontal-dividing-line mb-4 mt-4"
}, null, -1);
const _hoisted_74 = {
  class: "row mt-4"
};
const _hoisted_75 = {
  class: "col-lg-6 col-126"
};
const _hoisted_76 = {
  class: "pl-4 pr-4"
};
const _hoisted_77 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_78 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_79 = {
  class: "fw-bold fsi-24"
};
const _hoisted_80 = {
  key: 0,
  class: "fw-bold fsi-24"
};
const _hoisted_81 = {
  key: 1,
  class: "fw-bold fsi-24"
};
const _hoisted_82 = {
  class: "row mt-lg-4 mt-3"
};
const _hoisted_83 = {
  class: "col-lg-6 col-12"
};
const _hoisted_84 = {
  class: "pl-4 pr-4"
};
const _hoisted_85 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_86 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_87 = {
  class: "fw-bold fsi-24"
};
const _hoisted_88 = {
  key: 0,
  class: "fw-bold fsi-24"
};
const _hoisted_89 = {
  key: 1,
  class: "fw-bold fsi-24"
};
const _hoisted_90 = {
  class: "fw-medium fs-12"
};
const _hoisted_91 = {
  key: 0,
  class: "fw-bold fsi-24"
};
const _hoisted_92 = {
  key: 1,
  class: "fw-medium fs-12"
};
const _hoisted_93 = {
  class: "col-lg-6 col-12 mt-lg-0 mt-3"
};
const _hoisted_94 = {
  class: "pl-4 pr-4"
};
const _hoisted_95 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_96 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_97 = {
  class: "fw-bold fsi-24"
};
const _hoisted_98 = {
  key: 0,
  class: "fw-bold fsi-24"
};
const _hoisted_99 = {
  key: 1,
  class: "fw-bold fsi-24"
};
const _hoisted_100 = {
  class: "row mt-lg-4 mt-3"
};
const _hoisted_101 = {
  class: "col-lg-6 col-12"
};
const _hoisted_102 = {
  class: "pl-4 pr-4"
};
const _hoisted_103 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_104 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_105 = {
  class: "fw-bold fsi-24"
};
const _hoisted_106 = {
  key: 0,
  class: "fw-bold fsi-24"
};
const _hoisted_107 = {
  key: 1,
  class: "fw-bold fsi-24"
};
const _hoisted_108 = {
  class: "col-lg-6 col-12 mt-lg-0 mt-3"
};
const _hoisted_109 = {
  class: "pl-4 pr-4"
};
const _hoisted_110 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_111 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_112 = {
  class: "fw-bold fsi-24"
};
const _hoisted_113 = {
  key: 0,
  class: "fw-bold fsi-24"
};
const _hoisted_114 = {
  key: 1,
  class: "fw-bold fsi-24"
};
const _hoisted_115 = {
  key: 2,
  class: "row mt-3"
};
const _hoisted_116 = {
  class: "col-12 mt-3"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tooltip = _resolveComponent("Tooltip");
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
  const _component_i_skeleton = _resolveComponent("i-skeleton");
  const _component_AdCard2 = _resolveComponent("AdCard2");
  const _component_NextBtnGroup = _resolveComponent("NextBtnGroup");
  return _openBlock(), _createElementBlock("div", null, [$props.haveSp ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('common.Overview')), 1)]), _hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('Onboarding.Position Value')), 1), _createVNode(_component_Tooltip, null, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.Position Value tip')), 1)]),
    _: 1
  })]), _createElementVNode("div", _hoisted_10, _toDisplayString($options.externalFormatFilPrice(_ctx.positionValue)), 1)])])])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('Onboarding.Debt Value')), 1), _createVNode(_component_Tooltip, null, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.Debt Value Tips')), 1)]),
    _: 1
  })]), _createElementVNode("div", _hoisted_16, _toDisplayString($options.externalFormatFilPrice(_ctx.debtValue)), 1)])]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('Onboarding.Equity Value')), 1), _createVNode(_component_Tooltip, null, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.Equity Value Tip')), 1)]),
    _: 1
  })]), _createElementVNode("div", _hoisted_21, _toDisplayString($options.externalFormatFilPrice(_ctx.equityValue)), 1)])])]), _hoisted_22, _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t('Onboarding.Debt Ratio')), 1), _createVNode(_component_Tooltip, null, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.Debt Ratio Tips')), 1)]),
    _: 1
  })]), _createElementVNode("div", _hoisted_28, _toDisplayString($options.formatUnits(_ctx.debtRatio, 2)) + "%", 1)])]), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t('Onboarding.LiqThreshold')), 1), _createVNode(_component_Tooltip, null, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.LiqThreshold Tips')), 1)]),
    _: 1
  })]), _createElementVNode("div", _hoisted_33, _toDisplayString($options.formatUnits(_ctx.liquidationThreshold, 2)) + "%", 1)])])]), _createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$t('Onboarding.Maximum Debt Ratio')), 1)]), _createElementVNode("div", _hoisted_39, _toDisplayString($options.formatUnits(_ctx.maxDebtRatio, 2)) + "%", 1), _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t('Onboarding.Maximum Leverage')) + ": " + _toDisplayString($options.formatUnits(_ctx.currentNode.max_leverage, 4)) + "x", 1)])]), _createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [_createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.$t('Onboarding.Safety Buffer')), 1), _createVNode(_component_Tooltip, null, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.Safety Buffer Tip')), 1)]),
    _: 1
  })]), _createElementVNode("div", _hoisted_45, _toDisplayString($options.externalFormatFilPrice(_ctx.safetyBuffer)), 1)])])])], 64)) : _createCommentVNode("", true), !$props.haveSp ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.$t('common.Overview')), 1)]), _hoisted_48, _createElementVNode("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, [_createElementVNode("div", _hoisted_52, [_createElementVNode("div", _hoisted_53, [_createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.$t('Onboarding.Position Value')), 1), _createVNode(_component_Tooltip, null, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.Position Value tip')), 1)]),
    _: 1
  })]), _createVNode(_component_i_skeleton, {
    loading: _ctx.loading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_55, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [!$data.searchOk ? (_openBlock(), _createElementBlock("div", _hoisted_56, "- -")) : _createCommentVNode("", true), $data.searchOk ? (_openBlock(), _createElementBlock("div", _hoisted_57, _toDisplayString($options.formatPrice(_ctx.nodeInfo.positionValue)) + " FIL", 1)) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["loading"])])])])]), _createElementVNode("div", _hoisted_58, [_createElementVNode("div", _hoisted_59, [_createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.$t('Onboarding.Available Balance')), 1)]), _createVNode(_component_i_skeleton, {
    loading: _ctx.loading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_63, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [!$data.searchOk ? (_openBlock(), _createElementBlock("div", _hoisted_64, "- -")) : _createCommentVNode("", true), $data.searchOk ? (_openBlock(), _createElementBlock("div", _hoisted_65, _toDisplayString($options.formatPrice(_ctx.nodeInfo.availableBalance)) + " FIL", 1)) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["loading"])])]), _createElementVNode("div", _hoisted_66, [_createElementVNode("div", _hoisted_67, [_createElementVNode("div", _hoisted_68, [_createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.$t('Onboarding.Locked Rewards')), 1)]), _createVNode(_component_i_skeleton, {
    loading: _ctx.loading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_70, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [!$data.searchOk ? (_openBlock(), _createElementBlock("div", _hoisted_71, "- -")) : _createCommentVNode("", true), $data.searchOk ? (_openBlock(), _createElementBlock("div", _hoisted_72, _toDisplayString($options.formatPrice(_ctx.nodeInfo.lockedRewards, 4)) + " FIL", 1)) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["loading"])])])]), _hoisted_73, _createElementVNode("div", _hoisted_74, [_createElementVNode("div", _hoisted_75, [_createElementVNode("div", _hoisted_76, [_createElementVNode("div", _hoisted_77, [_createElementVNode("span", _hoisted_78, _toDisplayString(_ctx.$t('Onboarding.Initial Pledge')), 1)]), _createVNode(_component_i_skeleton, {
    loading: _ctx.loading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_79, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [!$data.searchOk ? (_openBlock(), _createElementBlock("div", _hoisted_80, "- -")) : _createCommentVNode("", true), $data.searchOk ? (_openBlock(), _createElementBlock("div", _hoisted_81, _toDisplayString($options.formatPrice(_ctx.nodeInfo.pledge)) + " FIL", 1)) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["loading"])])])]), _createElementVNode("div", _hoisted_82, [_createElementVNode("div", _hoisted_83, [_createElementVNode("div", _hoisted_84, [_createElementVNode("div", _hoisted_85, [_createElementVNode("span", _hoisted_86, _toDisplayString(_ctx.$t('Onboarding.Adjusted Power')), 1)]), _createVNode(_component_i_skeleton, {
    loading: _ctx.loading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_87, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [!$data.searchOk ? (_openBlock(), _createElementBlock("div", _hoisted_88, "- -")) : _createCommentVNode("", true), $data.searchOk ? (_openBlock(), _createElementBlock("div", _hoisted_89, _toDisplayString($options.formatBit(_ctx.nodeInfo.adjustedPower)), 1)) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["loading"]), _createVNode(_component_i_skeleton, {
    loading: _ctx.loading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_90, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "25%"
      }
    })])]),
    default: _withCtx(() => [!$data.searchOk ? (_openBlock(), _createElementBlock("div", _hoisted_91, "- -")) : _createCommentVNode("", true), $data.searchOk ? (_openBlock(), _createElementBlock("div", _hoisted_92, "Rate: " + _toDisplayString(_ctx.nodeInfo.adjustedPowerRate) + "%", 1)) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["loading"])])]), _createElementVNode("div", _hoisted_93, [_createElementVNode("div", _hoisted_94, [_createElementVNode("div", _hoisted_95, [_createElementVNode("span", _hoisted_96, _toDisplayString(_ctx.$t('Onboarding.Raw Byte Power')), 1)]), _createVNode(_component_i_skeleton, {
    loading: _ctx.loading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_97, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [!$data.searchOk ? (_openBlock(), _createElementBlock("div", _hoisted_98, "- -")) : _createCommentVNode("", true), $data.searchOk ? (_openBlock(), _createElementBlock("div", _hoisted_99, _toDisplayString($options.formatBit(_ctx.nodeInfo.rawBytePower)), 1)) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["loading"])])])]), _createElementVNode("div", _hoisted_100, [_createElementVNode("div", _hoisted_101, [_createElementVNode("div", _hoisted_102, [_createElementVNode("div", _hoisted_103, [_createElementVNode("span", _hoisted_104, _toDisplayString(_ctx.$t('Onboarding.Sector Size')), 1)]), _createVNode(_component_i_skeleton, {
    loading: _ctx.loading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_105, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [!$data.searchOk ? (_openBlock(), _createElementBlock("div", _hoisted_106, "- -")) : _createCommentVNode("", true), $data.searchOk ? (_openBlock(), _createElementBlock("div", _hoisted_107, _toDisplayString($options.formatBit(_ctx.nodeInfo.sectorSize, null)), 1)) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["loading"])])]), _createElementVNode("div", _hoisted_108, [_createElementVNode("div", _hoisted_109, [_createElementVNode("div", _hoisted_110, [_createElementVNode("span", _hoisted_111, _toDisplayString(_ctx.$t('Onboarding.Sector Count')), 1)]), _createVNode(_component_i_skeleton, {
    loading: _ctx.loading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_112, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [!$data.searchOk ? (_openBlock(), _createElementBlock("div", _hoisted_113, "- -")) : _createCommentVNode("", true), $data.searchOk ? (_openBlock(), _createElementBlock("div", _hoisted_114, _toDisplayString($options.formatPrice(_ctx.nodeInfo.sectorCount, 0)), 1)) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["loading"])])])])], 64)) : _createCommentVNode("", true), $props.haveSp ? (_openBlock(), _createElementBlock("div", _hoisted_115, [_createElementVNode("div", _hoisted_116, [_createVNode(_component_AdCard2, {
    title: _ctx.$t('Onboarding.This node has been delegated!'),
    "btn-text": _ctx.$t('Onboarding.View Node'),
    content: _ctx.$t('Onboarding.Please take good care the original owner'),
    onBtnClick: $options.viewNode
  }, null, 8, ["title", "btn-text", "content", "onBtnClick"])])])) : _createCommentVNode("", true), $data.showNextFlag ? (_openBlock(), _createBlock(_component_NextBtnGroup, {
    key: 3,
    onNext: $options.next,
    "show-pre": false
  }, null, 8, ["onNext"])) : _createCommentVNode("", true)]);
}